import { BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { getUrlParams } from 'utils/urlParams';

export const getInsightsURL = (
  medium: string,
  workflowId: string,
  dateParams: {
    startDateString?: string;
    endDateString?: string;
  } = {},
) => {
  const { startDateString, endDateString } = dateParams;
  const startTime = startDateString ? `&startTime=${startDateString}` : '';
  const endTime = endDateString ? `&endTime=${endDateString}` : '';

  return `messagingInsights?messageMediums=${medium}&workflowIds=${workflowId}${startTime}${endTime}`;
};

export const openLinkInNewTab = (path = '') =>
  window.open(`${window.location.origin}/${path}`, '_blank');

/**
 * Gets button variant for header depending on whether
 * workflow is in published or draft mode
 */
export const getButtonProps = (isPublished: boolean) => ({
  size: BUTTON_SIZES.LARGE,
  variant: isPublished ? BUTTON_VARIANTS.GHOST : BUTTON_VARIANTS.GHOSTINVERTED,
});

export const checkLastURL = (lastURL: string, projectId?: number) => {
  const lastURLIsInStudio = lastURL.includes('edit?mode=beta&workflowType=');
  const { projectId: lastProjectId } = getUrlParams(lastURL);
  const lastURLIsDiffProject = +lastProjectId !== projectId;
  return lastProjectId ? lastURLIsDiffProject : lastURLIsInStudio;
};
